import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  userDetails: null,
  emailId: "",
  roles: JSON.parse(localStorage.getItem("userRole")) || [],
  orderType: JSON.parse(localStorage.getItem("userOrderType")) || [],
  brand: JSON.parse(localStorage.getItem("userBrand")) || "",
  brandId: JSON.parse(localStorage.getItem("userBrandId")) || "",
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setEmailId: (state, action) => {
      state.emailId = action.payload;
    },
    setRole: (state, action) => {
      localStorage.setItem(
        "userRole",
        JSON.stringify(action?.payload?.length > 0 ? [...action.payload] : [])
      );
      state.roles = action?.payload?.length > 0 ? [...action.payload] : [];
    },
    setOrderType: (state, action) => {
      localStorage.setItem(
        "userOrderType",
        JSON.stringify(action?.payload?.length > 0 ? [...action.payload] : [])
      );
      state.orderType = action?.payload?.length > 0 ? [...action.payload] : [];
    },
    setUserBrand: (state, action) => {
      localStorage.setItem("userBrand", JSON.stringify(action.payload));
      state.brand = action.payload;
    },
    setUserBrandId: (state, action) => {
      localStorage.setItem("userBrandId", JSON.stringify(action.payload));
      state.brandId = action.payload;
    },
    resetUser: () => initialState, // Reset just this slice
  },
});

const userReducer = userSlice.reducer;

export const {
  setUserDetails,
  setEmailId,
  setRole,
  setOrderType,
  resetUser,
  setUserBrand,
  setUserBrandId,
} = userSlice.actions;

export default userReducer;
